// extracted by css-extract-rspack-plugin
export default {"root":"cveV9RYQ420MXZPx","hidden":"ouB9RyNEitQZQSGi"};